var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSquareStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check-Square--Streamline-Flex"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 100,
    height: 100,
    rx: 24,
    fill: "#00356C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-square--check-form-validation-checkmark-success-add-addition-box-square-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9999 2.28613C41.7999 2.28613 33.7928 3.03613 26.1214 3.89328C20.2916 4.56433 14.8615 7.19207 10.7178 11.3474C6.57417 15.5028 3.96172 20.9402 3.30707 26.7718C2.48564 34.4076 1.78564 42.3576 1.78564 50.5004C1.78564 58.6433 2.48564 66.5933 3.30707 74.229C3.96172 80.0606 6.57417 85.4981 10.7178 89.6534C14.8615 93.8088 20.2916 96.4365 26.1214 97.1076C33.7928 97.9647 41.7999 98.7147 49.9999 98.7147C58.1999 98.7147 66.2071 97.9647 73.8785 97.1076C79.7083 96.4365 85.1384 93.8088 89.282 89.6534C93.4257 85.4981 96.0381 80.0606 96.6928 74.229C97.5142 66.5933 98.2142 58.6433 98.2142 50.5004C98.2142 42.3576 97.5142 34.4076 96.6928 26.7718C96.0381 20.9402 93.4257 15.5028 89.282 11.3474C85.1384 7.19207 79.7083 4.56433 73.8785 3.89328C66.2071 3.03613 58.1999 2.28613 49.9999 2.28613Z",
    fill: "#00356C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1641 29.6432C71.5582 30.0774 71.8628 30.5851 72.0607 31.1371C72.2585 31.6891 72.3457 32.2747 72.3171 32.8604C72.2886 33.4461 72.145 34.0204 71.8944 34.5506C71.6439 35.0808 71.2914 35.5564 70.857 35.9503C65.2641 41.0218 61.4141 45.2646 58.2213 50.2432C55.007 55.2575 52.3498 61.2003 49.3427 69.8218C49.0926 70.5415 48.6624 71.1852 48.0932 71.6917C47.524 72.1981 46.8346 72.5505 46.0906 72.7152C45.3467 72.8798 44.573 72.8514 43.8432 72.6325C43.1134 72.4136 42.4517 72.0115 41.9213 71.4646L28.9355 58.0718C28.5275 57.6506 28.2064 57.1532 27.9906 56.6079C27.7748 56.0627 27.6685 55.4802 27.6778 54.8939C27.6966 53.7097 28.185 52.5815 29.0355 51.7575C29.8861 50.9334 31.0292 50.481 32.2134 50.4997C33.3976 50.5185 34.5258 51.0069 35.3498 51.8575L43.3998 60.1575C45.657 54.4289 47.9641 49.7075 50.707 45.4289C54.4641 39.5575 58.9212 34.7146 64.857 29.336C65.2912 28.942 65.7988 28.6373 66.3509 28.4395C66.9029 28.2416 67.4885 28.1545 68.0742 28.183C68.6599 28.2115 69.2342 28.3552 69.7644 28.6057C70.2946 28.8563 70.7702 29.2088 71.1641 29.6432Z",
    fill: "#F3FAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquareStreamlineFlex);
export default __webpack_public_path__ + "static/media/Check-Square--Streamline-Flex.fc129c4749aeba795cb49891b0f79c23.svg";
export { ForwardRef as ReactComponent };